/* global espn FB $ */
import React from 'react'

export default class Conversation extends React.Component {

  constructor() {
    super()
  }

  componentDidMount() {
    try {
      espn.plugins.getFacebook( function () {
        if ( !$('.fb-comments iframe').length ) {
          FB.XFBML.parse(document.body)
        }
      })
    } catch(e) {
      //no empties...
    }
  }
  

  shouldComponentUpdate( nextProps ) {
    if ( this.props.href == nextProps.href ) {
      return false
    }
    return true
  }

  render() {

    const text    = this.props.text || {}
    const href    = this.props.href || ''
      
    return (
      <article className="sub-module conversation">
        <header className="bordered">
          <h1>{ text.heading || '' }</h1>
        </header>
        <div className="content">
          <p className="condition" dangerouslySetInnerHTML={{ __html:text.description || '' }} />
          <div className="fb-comments" data-numposts="5" data-href={ href } data-width="100%"></div>
        </div>
      </article>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/rugby/components/Conversation.jsx
 **/